import { CheckIcon, DoubleCheckIcon, Warning, Timer } from 'app/components/icons'
import styles from './styles.module.scss'

function MessageStatus({ status }) {
  const iconForStatus = {
    failed: {
      icon: Warning,
      class: styles.user_status_icon,
      color: '#e63939',
    },
    pending: {
      icon: Timer,
      class: styles.user_status_icon,
      color: '#757575',
    },
    sent: {
      icon: CheckIcon,
      class: styles.user_check_icon,
      color: '#7C0069',
    },
    seen: {
      icon: DoubleCheckIcon,
      class: styles.user_double_check_icon,
      color: '#7C0069',
    },
  }

  const icon = iconForStatus[status]
  const IconComponents = iconForStatus[status]?.icon

  if (IconComponents) return <IconComponents className={icon.class} color={icon.color} />

  return <></>
}

export default MessageStatus
